import { getRawRequest, getRequest, patchRequest } from '../../utils'
import { BankAccount } from './types/bankAccount'

export interface BankAccountsResponse {
  data: BankAccount[]
}

export const fetchBankAccounts = (organizationId: string): Promise<BankAccountsResponse> => {
  return getRequest(`/reconciliation/organizations/${organizationId}/bank-accounts`)
}

export interface UpdateBankAccountPayload {
  organizationId: string
  bankAccountId: string
  customAccountName?: string | null
  reconciliationStartDate?: string | null
}

export const updateBankAccount = ({
  organizationId,
  bankAccountId,
  customAccountName,
  reconciliationStartDate,
}: UpdateBankAccountPayload) => {
  return patchRequest(`/reconciliation/organizations/${organizationId}/bank-accounts/${bankAccountId}`, {
    customAccountName,
    reconciliationStartDate,
  })
}

export interface DownloadBankLinesOptions {
  accountId: string
  locale: string
  organizationId: string
}

export const downloadBankLines = ({
  accountId,
  locale,
  organizationId,
}: DownloadBankLinesOptions): Promise<Response> => {
  const params = new URLSearchParams({ accountId, isReconciled: 'false' })

  return getRawRequest(`/organizations/${organizationId}/bankLines/download?${params.toString()}`, {
    'accept-language': locale,
  })
}
